import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

const Circle = memo(({ color, normalColor, fill, x, y, r, inner, outer }) => {
  const _styleContainer = useMemo(
    () => [
      styles.outer,
      {
        left: x - r,
        top: y - r,
        width: 2 * r,
        height: 2 * r,
        borderRadius: r,
      },
      { borderColor: 'transparent' },
      fill && { borderColor: color === '#fff' ? '#51bf92' : color },
      !outer && { borderWidth: 0 },
    ],
    [x, r, y, normalColor, color, fill, outer],
  );

  const _styleIner = useMemo(
    () => [
      !outer && styles.inner,
      {
        width: (2 * r) / 4,
        height: (2 * r) / 4,
        borderRadius: r / 4,
        // backgroundColor: fill ? color : "transparent",
        backgroundColor: color,
      },
    ],
    [r, outer, fill, color],
  );

  return (
    <View style={_styleContainer}>
      {inner ? <View style={_styleIner} /> : null}
    </View>
  );
});

Circle.displayName = 'Circle';

Circle.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.bool,
  x: PropTypes.number,
  y: PropTypes.number,
  r: PropTypes.number,
  inner: PropTypes.bool,
  outer: PropTypes.bool,
};

Circle.defaultProps = {
  inner: true,
  outer: true,
};

const styles = StyleSheet.create({
  outer: {
    position: 'absolute',
    borderColor: '#8E91A8',
    borderWidth: 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  inner: {
    backgroundColor: '#8E91A8',
  },
});

export default Circle;
